import { FC, ReactNode } from 'react';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';
import { StyledButton, StyledIcon } from './Button.styles';

type ButtonProps = {
  children?: ReactNode;
  disabled?: boolean;
  href?: string;
  icon?: ReactNode;
  isPrimary?: boolean;
  isSmall?: boolean;
  isLarge?: boolean;
  isInline?: boolean;
  isInverted?: boolean;
  isNarrow?: boolean;
  tagName?: any;
  className?: string;
  type?: string;
  testId?: string;
  onClick?: (any) => any;
  ariaLabel?: string;
  target?: string;
  isLoading?: boolean;
};

export const Button: FC<ButtonProps> = ({
  children,
  disabled = false,
  href,
  icon,
  isPrimary = false,
  isSmall = false,
  isLarge = false,
  isInline = false,
  isInverted = false,
  isNarrow = false,
  tagName,
  className,
  onClick,
  type,
  testId,
  ariaLabel,
  target,
  isLoading = false,
}) => (
  <StyledButton
    as={tagName}
    disabled={disabled}
    href={href}
    icon={icon}
    isPrimary={isPrimary}
    isSmall={isSmall}
    isLarge={isLarge}
    isInline={isInline}
    isInverted={isInverted}
    isNarrow={isNarrow}
    className={className}
    onClick={onClick}
    type={type}
    data-testid={testId}
    aria-label={ariaLabel}
    target={target}
  >
    {icon && <StyledIcon>{icon}</StyledIcon>}

    {children}
    {isLoading && <LoadingSpinner />}
  </StyledButton>
);
